import ko from 'knockout';
import $ from 'jquery';

    function HistoricalFilterFormatter(params, observableOptions, dataSources) {

        var self = this;

        self.observableOptions = observableOptions; 

        self.dataSources = dataSources;

        self.sourcetype = params && params.type ? params.type : "";

        self.observableParams = dataSources[0].observableParams;

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function ComposeData(sourcetype, sourcelist, options, initFlag, dataProvider, params) {

        if (sourcetype == "HistoricalIssuesFlexQuery") {
            if ($.isEmptyObject(sourcelist)) {
                return {
                    connectionStatuses: [],
                    disconnectReasons: [],
                    packetLossBands: [],
                };
            } else {
                return {
                    connectionStatuses: sourcelist.Table,
                    disconnectReasons: sourcelist.Table1,
                    packetLossBands: sourcelist.Table2,
                };
            }

        } else if ((sourcetype == "HistoricalManagedEndpointsFlexQuery") || (sourcetype == "HistoricalEndpointInventoryFlexQuery")) {

            if ((params.queryId == "HistoricalManagedEndpointsFlexQuery1") || (params.queryId == "HistoricalEndpointInventoryFlexQuery1")) {

                if ($.isEmptyObject(sourcelist)) {
                    return {
                        categories: [],
                    };
                } else {
                    return {
                        categories: sourcelist.Table,
                    };
                }
            } else {

                if ($.isEmptyObject(sourcelist)) {
                    return {
                        models: [],
                    };
                } else {
                    return {
                        models: sourcelist.Table,
                    };
                }

            }

        } else if ((sourcetype == "HistoricalMeetingsFlexQuery") || (sourcetype == "HistoricalMeetingVMRFlexQuery") || (sourcetype == "HistoricalMeetingParticipantFlexQuery")) {

            if ((params.queryId == "HistoricalMeetingsFlexQuery1") || (params.queryId == "HistoricalMeetingVMRFlexQuery1") || (params.queryId == "HistoricalMeetingParticipantFlexQuery1")) {

                if ($.isEmptyObject(sourcelist)) {
                    return {
                        types: [],
                    };
                } else {
                    return {
                        types: sourcelist.Table,
                        protocols: sourcelist.Table1,
                        calltypes: sourcelist.Table2
                };
                }
            } else if ((params.queryId == "HistoricalMeetingsFlexQuery2") || (params.queryId == "HistoricalMeetingVMRFlexQuery2") || (params.queryId == "HistoricalMeetingParticipantFlexQuery2")) {

                if ($.isEmptyObject(sourcelist)) {
                    return {
                        systemTypes: [],
                    };
                } else {
                    return {
                        systemTypes: sourcelist.Table,
                    };
                }
            } else {

                if ($.isEmptyObject(sourcelist)) {
                    return {
                        systems: [],
                    };
                } else {
                    return {
                        systems: sourcelist.Table,
                    };
                }

            }

        }

    }

    HistoricalFilterFormatter.prototype.RefreshData = function () {
        var self = this;

        self.sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.QueryResultDatasetDictionary, self.observableParams());

        if (self.sourceList != null)
            self.observableFormattedData(ComposeData(self.sourcetype, self.sourceList, self.observableOptions(), null, self.dataProvider, self.observableParams()));

    };

    HistoricalFilterFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    HistoricalFilterFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    HistoricalFilterFormatter.prototype.initialize = function (dataRepository, dataProvider) {
        var self = this;

        self.dataRepository = dataRepository;
        self.dataProvider = dataProvider;

        self.subscriptions.push(self.dataRepository.QueryResultDatasetDictionary.subscribe(function () { self.DataUpdated(); }));

        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(dataRepository.QueryResultDictionary()))
            self.RefreshData();
    };


    HistoricalFilterFormatter.prototype.getObservableData = function () {
        var self = this;

        return self.observableFormattedData;
    };

    HistoricalFilterFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default HistoricalFilterFormatter;
